<template>
    <b-modal id="modal-konfirmasi-angsuranSaja" title="Konfirmasi Pembayaran Angsuran Saja" size="lg" 
        no-close-on-backdrop no-close-on-esc :hide-header-close="isSubmitting"
        :ok-title="isSubmitting ? 'Membayar...' : 'Bayar'" 
        :ok-disabled="isSubmitting"
        @ok.prevent="doSubmit"
        cancel-title="Tutup" auto-focus-button="ok"
    >
        Konfirmasi untuk melakukan pembayaran angsuran Pokok
        <div class="detail-data-wrapper mt-4 mb-4">
            <h6 class="form-title mb-2">DATA PEMBAYARAN</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Sisa Pokok</b-col>
                <b-col>
                    <strong>
                        Rp. {{ $helper.addThousandSeparator(sisaPokok) }}
                    </strong>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                <b-col>
                    <strong>
                        Rp. {{ $helper.addThousandSeparator(angsuranPokok) }}
                    </strong>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Sisa Pokok setelah Pembayaran</b-col>
                <b-col>
                    <strong>
                        Rp. {{ $helper.addThousandSeparator(sisaPokok - angsuranPokok) }}
                    </strong>
                </b-col>
            </b-row>
        </div>
        Pastikan anda telah menerima uang sebesar angsuran pokok.
    </b-modal>
</template>

<script>
export default {
    name: 'modal-konfirmasi-angsuran',
    props: {
        isSubmitting: { type: Boolean, required: true },
        angsuranPokok: { type: Number, required: true },
        sisaPokok: { type: Number, required: true },
    },
    methods: {
        doSubmit() {
            this.$emit("exec-submit")
        }

    }
}
</script>